import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEmbarcaderoComponent } from './simple-icons-embarcadero.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEmbarcaderoComponent ],
    exports:      [ SimpleIconsEmbarcaderoComponent ],
    bootstrap:    []
})
export class SimpleIconsEmbarcaderoModule {}
